import { useEffect, useState } from 'react'

export function useCountdown(startSeconds: number) {
  const [remaining, setRemaining] = useState(startSeconds)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((s) => (s > 0 ? s - 1 : 0))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  const minutes = String(Math.floor(remaining / 60)).padStart(2, '0')
  const seconds = String(remaining % 60).padStart(2, '0')
  return { minutes, seconds, expired: remaining === 0 }
}
